import { render, staticRenderFns } from "./PaymentURL.vue?vue&type=template&id=ebf00874&scoped=true&"
import script from "./PaymentURL.vue?vue&type=script&lang=js&"
export * from "./PaymentURL.vue?vue&type=script&lang=js&"
import style0 from "./PaymentURL.vue?vue&type=style&index=0&id=ebf00874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf00874",
  null
  
)

export default component.exports